import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Wrench, LogOut, Menu, X } from "lucide-react";
import { useState } from "react";

const LINKS = [
  { to: "/diagnosi", label: "Diagnosi", testid: "nav-link-diagnosi" },
  { to: "/codici-obd", label: "Codici OBD-II", testid: "nav-link-obd" },
  { to: "/guide", label: "Guide", testid: "nav-link-guide" },
  { to: "/storico", label: "Storico", testid: "nav-link-history" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    nav("/");
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#0B0F14]/85 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand-logo" className="flex items-center gap-2.5 group">
          <span className="w-9 h-9 rounded-lg bg-[#F97316] flex items-center justify-center shadow-[0_0_20px_rgba(249,115,22,0.45)] group-hover:rotate-12 transition-transform">
            <Wrench className="w-5 h-5 text-black" strokeWidth={2.5} />
          </span>
          <span className="font-display font-black text-xl tracking-wide">
            MOTORA<span className="text-[#F97316]">.AI</span>
          </span>
        </Link>

        {user && (
          <nav className="hidden md:flex items-center gap-1">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  loc.pathname === l.to
                    ? "text-[#F97316] bg-[#F97316]/10"
                    : "text-zinc-400 hover:text-white hover:bg-white/5"
                }`}
              >
                {l.label}
              </Link>
            ))}
          </nav>
        )}

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <span className="hidden sm:block text-sm text-zinc-400 font-mono">{user.name}</span>
              <button
                data-testid="nav-logout-btn"
                onClick={handleLogout}
                className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm text-zinc-300 hover:text-white hover:bg-white/5 transition-colors"
              >
                <LogOut className="w-4 h-4" /> Esci
              </button>
              <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
                {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
              </button>
            </>
          ) : (
            <Link
              to="/accedi"
              data-testid="nav-auth-button"
              className="px-4 py-2 rounded-lg bg-[#F97316] hover:bg-[#EA580C] text-black font-semibold text-sm transition-colors shadow-[0_0_20px_rgba(249,115,22,0.35)]"
            >
              Accedi
            </Link>
          )}
        </div>
      </div>

      {user && open && (
        <nav className="md:hidden border-t border-white/10 bg-[#0B0F14] px-5 py-3 flex flex-col gap-1">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={`px-4 py-2.5 rounded-lg text-sm font-medium ${
                loc.pathname === l.to ? "text-[#F97316] bg-[#F97316]/10" : "text-zinc-300"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}
